/* import __COLOCATED_TEMPLATE__ from './tab-header-area.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';
import { modifier } from 'ember-modifier';

export default class TabHeaderArea extends Component {
    tagName = '';

    @service('aditools-analytics') analytics;
    @service('data') model;
    @service intl;
    @service hashService;
    @service tabService;
    @service selectionData;
    @service errorHandling;
    @service partData;

    @tracked enabledTabs = this.tabService.tabs.items.main;
    @tracked activeTab = this.enabledTabs.find((x) => x.isSelected).name;

    ////////////////////////////////////////////////////////////////////////////////
    // Properties                                                                 //
    ////////////////////////////////////////////////////////////////////////////////

    get videoMessage() {
        const translationArgs = {
            analogInputModel: this.intl.t('urls.videos.analogInputModel'),
            kickbackCalculations: this.intl.t('urls.videos.kickbackCalculations'),
            designingRCFilter: this.intl.t('urls.videos.designingRCFilter'),
            simulatingAnalogInputModel: this.intl.t('urls.videos.simulatingAnalogInputModel'),
            precisionAdcDriverTool: this.intl.t('urls.videos.precisionAdcDriverTool'),
            driverRingingAndInstability: this.intl.t('urls.videos.driverRingingAndInstability'),
            distortionCausedByLargeRfilt: this.intl.t('urls.videos.distortionCausedByLargeRfilt'),
            sarAdcsWithReducedKickback: this.intl.t('urls.videos.sarAdcsWithReducedKickback'),
            loopGainInOpAmps: this.intl.t('urls.videos.loopGainInOpAmps'),
            bodePlotsAndOpAmps: this.intl.t('urls.videos.bodePlotsAndOpAmps'),
            decompensatedOpAmps: this.intl.t('urls.videos.decompensatedOpAmps'),
            drivingACapacitiveLoad: this.intl.t('urls.videos.drivingACapacitiveLoad'),
            parasiticCapacitanceInOpAmps: this.intl.t('urls.videos.parasiticCapacitanceInOpAmps'),
        };
        return htmlSafe(this.intl.t('icon_modal.video.body', translationArgs));
    }

    get helpMessage() {
        return htmlSafe(this.intl.t('icon_modal.about_help.body'));
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Component Actions                                                          //
    ////////////////////////////////////////////////////////////////////////////////
    @action selectTab(tab) {
        this.activeTab = tab;

        const selectedTab = this.tabService.tabs.items.main.find((x) => x.name === tab);
        this.tabService.goToTab(selectedTab);
        this.tabService.updateTabs(this.model);
        this.hashService.handleUrlParameters();

        if (selectedTab.type.sendAnalyticsEventOnTabChange) {
            this.analytics.setWebEvent(this.partData.toolName, 'Main Tab', selectedTab.description || selectedTab.name);
        }
    }

    @action tabIsDisabled(tab) {
        return !this.enabledTabs.map((x) => x.name).includes(tab);
    }

    @action openToolbarAction(toolbar) {
        this.analytics.setWebEvent(this.partData.toolName, 'Toolbar Link', `${toolbar}`);
    }

    sharePopup = modifier(() => {
        const dialog = document.querySelector('#share-dialog');
        dialog.showModal();
    });

    @action closeShareDialog(doClose, evt) {
        const dialog = document.querySelector('#share-dialog');
        const popup = document.querySelector('#share-popup');
        const target = evt.target;
        if (!popup.contains(target)) {
            dialog.close();
            doClose();
        }
    }
}
